import React from 'react';
import { observer } from 'mobx-react';
import { MenuTemplate } from 'themes/components';
import { useStores } from 'core/stores/StoreContext';

const BaasicMenu = observer((props) => {
    const { routerStore, menuStore } = useStores();
    return <MenuTemplate {...props} routerStore={routerStore} menuStore={menuStore} />;
});

export default BaasicMenu;
